// import { InputTextarea } from "revagency-component-library";

export default defineNuxtPlugin((nuxtApp) => {
    // nuxtApp.vueApp.component("RCLInputTextarea", InputTextarea);
    // nuxtApp.vueApp.component("RCLLargeComponentTest", LargeComponentTest);
});
